module.exports = __webpack_public_path__ + "static/web-scraping-automation-sm-963b8204a5784a76f32be8feaccc1db8.png";